import { useMutation } from '@tanstack/react-query';
import secureApi from '../secureApi';
import type { AddressSuggession } from '@/types/postcode/AddressSuggession';

type AddressPayload = {
  postal_code: string;
  [key: string]: any;
};

type RawAddress = {
  AddressKey: string;
  CountryISO2?: string;
  TraditionalCounty?: string;
  AdministrativeCounty?: string;
  Organisation?: string;
  Department?: string;
  BuildingNumber?: string;
  PoBox?: string;
  Postcode?: string;
  Locality?: string;
  ThoroughfareName?: string;
  ThoroughfareDesc?: string;
  DependentThoroughfareName?: string;
  DependentThoroughfareDesc?: string;
  SubBuildingName?: string;
  BuildingName?: string;
};

type D8Result = {
  RawAddress: RawAddress;
  Address: { Lines: string[] };
};

const lookupAddressData8 = async (payload: AddressPayload) => {
  const res = await secureApi('/get-addresses', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  const data: any = await res.json();

  const results: D8Result[] = data?.responseObject?.Results || [];
  const suggestions: AddressSuggession[] = results.map((res) => {
    const Raw = res.RawAddress || {};
    const address = {
      addressID: Raw.AddressKey,
      country: Raw.CountryISO2 || 'GB',
      county: Raw.TraditionalCounty || Raw.AdministrativeCounty || '',
      district: Raw.AdministrativeCounty || '',
      name: Raw.Organisation || Raw.Department || Raw.BuildingName || Raw.SubBuildingName || '',
      number: Raw.BuildingNumber || '',
      poBox: Raw.PoBox || '',
      postcode: Raw.Postcode || '',
      postTown: Raw.Locality || '',
      street1: [Raw.ThoroughfareName, Raw.ThoroughfareDesc].filter(Boolean).join(' '),
      street2: [Raw.DependentThoroughfareName, Raw.DependentThoroughfareDesc]
        .filter(Boolean)
        .join(' '),
      subBuilding: Raw.SubBuildingName || Raw.BuildingName || '',
    };

    const label = res.Address.Lines.filter(Boolean).join(', ');

    return {
      label,
      value: { address: label, ...address, rawResponse: res },
    };
  });

  return { suggestions, postCode: payload.postCode };
};

const useAddressLookup = () => {
  return useMutation({
    mutationFn: lookupAddressData8,
  });
};

export default useAddressLookup;
